import { Component, OnInit, HostBinding, Input, ViewChild, ElementRef, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CiamService } from 'src/app/_services/ciam.service';
import { StorageService } from 'src/app/_services/storage.service';
import { ConfigStateService, CurrentUserDto } from '@abp/ng.core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CustomerService } from 'src/publicproxy/src/proxy/public/customer';
import { UserStore } from 'src/app/store/user.store';
import { GTM } from 'src/app/_services/gtm.service';

@Component({
  selector: 'ng-casto-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  @Input() context: string;
  connectedUser: CurrentUserDto;

  @HostBinding("class.configuration") get isInConfiguration(): boolean { return this.router.url.indexOf("/configuration") > 0 };
  @HostBinding("class.customer") get isCustomerContext(): boolean { return this.context === 'customer' };
  @HostBinding("class.configuration") get isLogin(): boolean {
    return this.location.path().includes('connexion') || this.location.path().includes('auth/callback');
  }

  @ViewChild('sidebar') sidebar: ElementRef;

  isMenuOpen: boolean = false;

  constructor(public router: Router,
    private customerService: CustomerService,
    private location: Location,
    private ciamService: CiamService,
    private storageService: StorageService,
    private injector: Injector,
    public config: ConfigStateService,
    public userStore: UserStore,
    private gtm: GTM) {
    router.events.subscribe(() => {
      this.isMenuOpen = false;
    })
  }

  ngOnInit(): void {
    if (this.context === 'customer' && this.storageService.isLoggedIn()) {
      this.customerService.getCustomer().subscribe((c) => this.userStore.setCustomer(c));
    } else {
      this.connectedUser = this.config.getOne("currentUser");
    }

    // Déconnexion depuis un autre onglet : celui-ci ne doit pas laisser naviguer sur une session close.
    this.storageService.getLoggedOutElsewhere().subscribe(() => this.leaveSession());

    this.storageService.getLogged().subscribe((x) => {
      if (x) {
        this.customerService.getCustomer().subscribe((c) => this.userStore.setCustomer(c));
      }
    });
  }

  askLogout() {
    this.injector.get(OAuthService).revokeTokenAndLogout();
  }

  async logout(): Promise<void> {
    if (this.context !== 'customer') {
      this.injector.get(OAuthService).revokeTokenAndLogout();
      return;
    }

    this.ciamService.logout().subscribe(() => this.leaveSession());
  }

  private async leaveSession(): Promise<void> {
    this.userStore.clearUserConnected();
    this.userStore.clearUserCard();
    this.userStore.clearCustomer();
    await this.router.navigate(['/connexion']);
  }

  navigateTo(url: string) {
    this.gtm.trackInteraction("outbound_click",
      "Nous contacter", { "target": url });
    window.open(url, '_blank').focus();
  }
}
